// Echoes the selected value into the option's legend, e.g.
// "WOOD SPECIES — Sakura". Lets each swatch and pill show only its own name
// instead of carrying a second line, which is where most of the visual noise
// in the old picker came from.
//
// Works off the radios themselves rather than the theme's variant JS, because
// the same treatment is used for real variant options (Wood Species, Leather
// Cover) and for cart line-item properties (Height, Sasawashi Color) — the
// latter have no server-side selected_value to hook into.
(function () {
  var SELECTOR = '[data-kenwork-echo]';

  function labelFor(input) {
    return input.getAttribute('data-echo-label') || input.value || '';
  }

  function sync(fieldset) {
    var echo = fieldset.querySelector(SELECTOR);
    if (!echo) return;
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    echo.textContent = labelFor(checked);
  }

  function fieldsetFor(el) {
    return el.closest ? el.closest('fieldset') : null;
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.type !== 'radio') return;
    var fieldset = fieldsetFor(target);
    if (fieldset) sync(fieldset);
  });

  function syncAll() {
    document.querySelectorAll(SELECTOR).forEach(function (echo) {
      var fieldset = fieldsetFor(echo);
      if (fieldset) sync(fieldset);
    });
  }

  document.addEventListener('DOMContentLoaded', syncAll);
  // Variant changes re-render the picker section, so re-sync afterwards.
  document.addEventListener('variant:change', syncAll);
  syncAll();
})();
